module.exports = __webpack_public_path__ + "img/anli1.7f93c37e.png";